export const simpleItemsExample = [
  {
    id: 0,
    value: 'Breadcrumb 1',
    href: '',
  },
  {
    id: 1,
    value: 'Breadcrumb 2',
    href: '',
  },
  {
    id: 2,
    value: 'Breadcrumb 3',
    href: '',
  },
];

export const longTextItemsExample = [
  {
    id: '0',
    value: 'Very Long Breadcrumb Item That Should Break Properly',
    href: '',
  },
  {
    id: '1',
    value: 'AnotherVeryLongBreadcrumbWithoutSpacesForTesting',
    href: '',
  },
  {
    id: '2',
    value: 'Final Item',
    href: '',
  },
];
